// src/components/map-pin/index.tsx
import MapPinMobileComponent from 'components/map-pin-mobile'
import MapPinWebComponent from 'components/map-pin-web'
import { LocationProps } from 'types/CommonTypes'
import { isWeb } from 'utils/constants'

interface MapPinComponentProps {
  isShow: boolean
  currentLocation: LocationProps
  customHeight?: string
  onClose: () => void
  onSave: (v: any) => void
}

const MapPinComponent: React.FC<MapPinComponentProps> = (props) => {
  const { isShow, currentLocation, customHeight, onClose, onSave } = props

  if (!isShow) return null

  return isWeb ? (
    <MapPinWebComponent
      currentLocation={currentLocation}
      mapHeight={true}
      customHeight={customHeight || '55vh'} // Default web height
      onSave={onSave}
    />
  ) : (
    <MapPinMobileComponent
      currentLocation={currentLocation}
      mapHeight={true}
      customHeight={customHeight || '90vh'} // Default mobile height
      onClose={onClose}
      onSave={onSave}
    />
  )
}

export default MapPinComponent
